import { Box, Stack, Typography } from "@mui/material";
import WarningIconOutlined from "@mui/icons-material/WarningAmberRounded";

interface ErrorComponentProps {
  smallScreen?: boolean;
  error: string;
}
const ErrorsDisplay: React.FC<ErrorComponentProps> = ({
  error,
  smallScreen,
}) => {
  return (
    <div>
      <Stack className="displayCenter" sx={{ my: 5 }}>
        <Box className="Animation">
          <WarningIconOutlined color="error" sx={{ fontSize: 100 }} />
        </Box>
        <Box textAlign="center" gap={1}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
            }}
          >
            Oops! Something's Gone Wrong.
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#555555",
            }}
          >
            <>{error}</>
          </Typography>
        </Box>
      </Stack>
    </div>
  );
};

export default ErrorsDisplay;
